import script from "./ActivityEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivityEdit.vue?vue&type=script&setup=true&lang=js"

import "./ActivityEdit.vue?vue&type=style&index=0&id=4323bd7f&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/duanju_admin_vue_live/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4323bd7f"]])

export default __exports__